export default "__VITE_ASSET__BRch$q1H__"